import "./stylesheets/main.scss";

import App from "./app";

App.init();
